<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jYZRm2/tc-custom/9781952871405.jpg?1704568357215" alt="This image is the cover for the book Powerhouse Voices, Volume 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Powerhouse Voices, Volume 2
      </h1>
      <p class="bookDescription body article font2">
        <p>The second book of <i>Powerhouse Voices: Amazing Experiences on Clubhouse</i> continues with more success stories that happened on an audio-only app that changed the world and helped people connect on a deeper level.<br/><br/>Celebrities, influencers, life coaches, CEOs, authors, artists, and leading entrepreneurs share the best advice to level up on all platforms, expand visibility and reach, increase your client base and prosperity.<br/><br/>Created by <i>USA Today</i>Bestselling Author, Naleighna Kai<br/>Featuring New York Times Bestselling Author Mary B. Morrison, Ehryck Gilmore, Stephanie M. Freeman, J. L. Woodson, La Ammitai, Darryl Benally, Chi Love, Jacquie Branagan, Matt Sandy, Glenn Rudin, Jeremy Burright, Sir Marco Robinson, Bobby Del Rio, Dan Eisen, and Michael “Health Unicorn” Montgomery.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Naleighna Kai, Mary B. Morrison, J. L. Woodson, Ehryck Gilmore, Stephanie M. Freeman, La Ammitai, Darryl Benally, Chi Love,, Matt Sandy, Jacquie Branagan, Glen Rudin, Jeremy Burright, Dan Eisen, Bobby Del Rio, Sir Marco Robinson, Michael Montgomery
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macro Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a93e0ce6